import { render, staticRenderFns } from "./HistoryRow.vue?vue&type=template&id=0dda5dc6&scoped=true"
import script from "./HistoryRow.vue?vue&type=script&lang=js"
export * from "./HistoryRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dda5dc6",
  null
  
)

export default component.exports